import { render, staticRenderFns, recyclableRender, components } from "./uni-popup.vue?vue&type=template&id=db6fc938&"
var renderjs
import script from "./uni-popup.vue?vue&type=script&lang=js&"
export * from "./uni-popup.vue?vue&type=script&lang=js&"
import style0 from "./uni-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-popup.vue"
export default component.exports